document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fragrance-section').forEach(function (section) {
    var tabs = section.querySelectorAll('.fragrance-tab');
    var deskImage = section.querySelector('.desk-image');
    var mobiImage = section.querySelector('.mobi-image');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var newDesktop = tab.dataset.imageDesktop;
        var newMobile = tab.dataset.imageMobile;

        tabs.forEach(function (t) {
          t.classList.remove('active');
        });
        tab.classList.add('active');

        if (deskImage) {
          deskImage.classList.add('is-fading');
          setTimeout(function () {
            deskImage.src = newDesktop;
            deskImage.classList.remove('is-fading');
          }, 100);
        }

        if (mobiImage) {
          mobiImage.classList.add('is-fading');
          setTimeout(function () {
            mobiImage.src = newMobile;
            mobiImage.classList.remove('is-fading');
          }, 100);
        }
      });
    });
  });
});
